// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";

const description =
  "A configurable timeline widget, ideal for helping readers understand a recent event by informing them of those that preceded it.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Timeline",
  id: "timeline",
  groupsWithAccess: ["specialist_user", "editor_user"],
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/timeline5/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "TimelineConfigTool" */ "app/components/tools/TimelineConfigTool/TimelineConfigTool"),
    loading: DynamicImportLoader,
    modules: ["TimelineConfigTool"]
  })
};

export default CONFIG;
